/**
 * عميل Supabase الوحيد المسموح.
 *
 * يُستورد `createClient` في هذا الملف فقط (قاعدة ESLint تمنع غير ذلك).
 * يستخدم مفتاح anon العام فقط؛ مفتاح service role ممنوع في أي كود يعمل
 * في المتصفح أو Electron. الحماية الفعلية تأتي من RLS في PostgreSQL.
 */

import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { AppError } from '@/domain/errors';
import { env } from '@/config/env';

let client: SupabaseClient | null = null;

export function getSupabaseClient(): SupabaseClient {
  if (client) return client;
  const url = env.supabaseUrl;
  const key = env.supabaseAnonKey;
  if (!url || !key) {
    throw AppError.validation(
      'إعدادات Supabase غير مكتملة. عيّن VITE_SUPABASE_URL و VITE_SUPABASE_ANON_KEY في ملف .env.',
    );
  }
  client = createClient(url, key, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    global: {
      headers: { 'x-application-name': 'taskflow' },
    },
  });
  return client;
}

/**
 * عميل مؤقت بلا تخزين جلسة، لإنشاء حساب موظف من لوحة التحكم دون المساس
 * بجلسة المدير. يعمل بالمفتاح العام فقط (نفس مسار التسجيل العادي).
 */
export function createEphemeralClient(): SupabaseClient {
  const url = env.supabaseUrl;
  const key = env.supabaseAnonKey;
  if (!url || !key) {
    throw AppError.validation('إعدادات Supabase غير مكتملة.');
  }
  return createClient(url, key, {
    auth: {
      persistSession: false,
      autoRefreshToken: false,
      detectSessionInUrl: false,
      flowType: 'pkce',
      storageKey: `taskflow-provisioning-${crypto.randomUUID()}`,
    },
    global: {
      headers: { 'x-application-name': 'taskflow-provisioning' },
    },
  });
}

/** للاختبارات فقط: إعادة إنشاء العميل بعد تغيير الإعدادات. */
export function resetSupabaseClient(): void {
  client = null;
}
